export enum SubscriptionStatusActionType {
  RECONNECTED_EVENT = 'pubnub/RECONNECTED_EVENT',
  CONNECTED_EVENT = 'pubnub/CONNECTED_EVENT',
}
